import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import moment from "moment";
import {Spinner} from "react-bootstrap-v5";
import ReactToPrint from "react-to-print";
import { reportService } from "../../Services/reportService";
import { customerServiceService } from "../../Services";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class CustomerService extends Component {
  state = {
    reportObj: [],
    startDate: "",
    endDate: "",
    searchText: "",
    CSList: [],
    loader:false
  };

  componentDidMount() {
    this.componentRef = React.createRef();
    this.getCustomerService();
    this.getCustomerServiceList();
  }

  getCustomerService = (params = {}) => {
    this.setState({loader:true})
    reportService.getCustomerService(params).then((result) => {
      if (result.status === true) {
        this.setState({ reportObj: result.data });
      } else {
        toast.info("Something went wrong");
      }
    this.setState({loader:false})
    });
  };

  // getCustomerServiceList = (param = {item : 438}) => {
  //   customerServiceService.CustomerServiceList(param).then((res) => {
  //     if(res?.status){
  //       let arr = res.data.filter((item) => item.department === 'CUSTOMERSERVICE')
  //       this.setState({ CSList : [...arr]})
  //     }
  //   })
  // }


  getCustomerServiceList = () => {
    let param = {role : "customer_service"} 
  customerServiceService.getCustomerService(param).then((res) => {
    if (res.status) {
      let arr = [];
      for (let i = 0; i < res.data.length; i++) {
        if(res.data[i].employee_name){
          arr.push({
            ...res.data[i],
            value: res.data[i]?.employee_name,
            label: res.data[i]?.employee_name,
          });
        }
      }
      this.setState({ CSList : [...arr]})
    }
  });
  };


  handleSearch = (e) => {
    const { value } = e.target;
    this.setState({ searchText: value },()=>{
        let search = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            searchText: value,
          };
          this.getCustomerService(search);
    });
   
  };

  exportToExcel = () => {
    let params = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      searchText: this.state.searchText,
    };
    reportService.exportCustomerService(params).then((result) => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

//   handleDateChange = (e) => {
//     const { name, value } = e.target;
//     let setdate = name === "start_date" ? "startDate" : "endDate";
//     this.setState({ [setdate]: new Date(value).getTime() }, () => {
//       if (this.state.startDate !== "" && this.state.endDate !== "") {
//         let search = {
//           startDate: this.state.startDate,
//           endDate: this.state.endDate,
//           searchText: this.state.searchText,
//         };
//         this.getCustomerService(search);
//       }
//     });
//   };

 //date selection function //neha
handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";
  
    const selectedDate = new Date(value).getTime();
    this.setState({ [setdate]: selectedDate }, () => {
      const { startDate, endDate } = this.state;
  
      if (startDate !== "" && endDate !== "") {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");
        
        } else {
            let search = {
                          startDate: this.state.startDate,
                          endDate: this.state.endDate,
                          searchText: this.state.searchText,
                      };
          this.getCustomerService(search);
        }
      }
    });
  };
  render() {
    const { reportObj,CSList } = this.state;
    let revTotal = 0,
      costTotal = 0,
      profitTotal = 0;

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Customer Service</h4>
        </div>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
            <Form.Label>Search</Form.Label>
              <Form.Select
                aria-label="Default select example"
                name="type"
                onChange={(e) => this.handleSearch(e)}
              >
                 <option value="">Select All</option>
                {CSList.map((item,index) => {
                  return (
                    <option key={index} value={item.employee_name}>{item.employee_name}</option>
                  )
                })}
              </Form.Select>


              {/* <Form.Label>Search</Form.Label>
              <Form.Control
                type="text"
                name="search_text"
                placeholder="CS Name/Sales Person"
                onChange={(e) => this.handleSearch(e)}
              /> */}
            </Col>

            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3} className="mt-3">
              <div className="d-flex justify-content-end">
              <Button
                className="me-3 ps-4 pe-4"
                variant="success"
                onClick={() => this.exportToExcel()}
              >
                Excel
              </Button>
              <ReactToPrint
                trigger={() => {
                  return <Button variant="secondary" className="ps-4 pe-4">Print</Button>;
                }}
                content={() => this.componentRef}
                bodyClass={"printElement"}
              />
              </div>
            </Col>
          </Row>

          <Row className="printElement" ref={(el) => (this.componentRef = el)}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>CS Name</th>
                  <th>Sales Person</th>
                  <th>Job Number</th>
                  <th>Date</th>
                  <th>Customer Name</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Revenue</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>Profit in %</th>
                </tr>
              </thead>
              {this.state.loader &&
                    <tbody>
                        <tr>
                            <td colSpan={20} className='text-center'>
                        <Spinner animation="border" />
                            </td>
                        </tr>
                    </tbody> 
                  || 
              <tbody>
                {reportObj.length &&
                  reportObj.map((item, index) => {
                    let rev =
                      item.invoices && item.invoices.invoice_lc_amount
                        ? item.invoices.invoice_lc_amount
                        : 0;
                    let cost =
                      item.costs && item.costs.cost_lc_amount
                        ? item.costs.cost_lc_amount
                        : 0;
                    let profit = rev - cost; // Get Profit
                    let profitPer =
                      profit !== 0 && cost !== 0 ? (profit / cost) * 100 : 0;
                    revTotal = rev + revTotal;
                    costTotal = cost + costTotal;
                    profitTotal = profit + profitTotal;

                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          {item?.general_details &&
                            item?.general_details?.customer_service}
                        </td>
                        <td>
                          {
                            item?.general_details?.sales_person?.contact_name
                            ? item?.general_details?.sales_person?.contact_name
                            : item?.general_details?.sales_person
                            ? item?.general_details?.sales_person
                            : item?.customer_details?.sales_person
                            ? item.customer_details.sales_person
                            : '-'
                          }
                        </td>
                        <td>{item?.job_token}</td>
                        <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                        <td>{item.customer_details?.name}</td>
                        <td>{item?.shipment_details?.origin 
                            ? item?.shipment_details?.origin_country
                            ? item.shipment_details?.origin +", "+ item.shipment_details?.origin_country
                            : item.shipment_details?.origin
                            : "-"
                        }</td>
                        <td>{item?.shipment_details?.destination 
                            ? item?.shipment_details?.destination_country
                            ? item.shipment_details?.destination +", "+ item.shipment_details?.destination_country
                            : item.shipment_details?.destination
                            : "-"
                        }</td>
                        {/* <td>{item?.shipment_details?.origin}</td>
                        <td>{item?.shipment_details?.destination}</td> */}
                        <td>{rev.toFixed(2)}</td>
                        <td>{cost.toFixed(2)}</td>
                        <td>{profit.toFixed(2)}</td>
                        <td>{profitPer.toFixed(2)}</td>
                      </tr>
                    );
                  }) || <tr><td colSpan={20} className="text-center">Data Not Available</td></tr>
                  }

                {
                  <tr>
                    <td colSpan={7}>
                      <strong>Total</strong>
                    </td>

                    <td>{revTotal.toFixed(2)}</td>
                    <td>{costTotal.toFixed(2)}</td>
                    <td>{profitTotal.toFixed(2)}</td>
                    <td colSpan={2}></td>
                  </tr>
                }
              </tbody>}
            </Table>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { CustomerService };
